@use "Styles/includes/variables";
@use "Styles/mixins" as mixins;

:host {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.poll {
    background: mixins.get-color(bg, solid, primary);
    border-radius: 16px;
    box-shadow:
        0px -24px 48px -12px rgba(10, 13, 18, 0.18),
        0px 4px 4px -2px rgba(10, 13, 18, 0.04);
    padding: 24px 0;
    width: 100%;
    max-width: 390px;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    @at-root :host([mode="sheet"]) & {
        max-width: none;
        padding-top: 0;
        border-radius: 0;
        box-shadow: none;
    }

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px 8px;
        border-bottom: 1px solid mixins.get-color(border, border-secondary);
        flex-shrink: 0;

        @at-root :host([mode="sheet"]) & {
            display: none;
        }
    }

    &__body {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        scrollbar-width: thin;
        scrollbar-color: mixins.get-color(foreground, fg-disabled-subtle) transparent;

        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: mixins.get-color(foreground, fg-disabled-subtle);
            border-radius: 100px;
        }
    }

    &__title {
        font-family: variables.$fontQuaternary;
        font-weight: 700;
        font-size: 20px;
        line-height: 30px;
        color: mixins.get-color(text, text-primary);
    }

    &__close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        padding: 0;
        border: none;
        background: transparent;
        color: mixins.get-color(text, text-primary);
        cursor: pointer;
    }

    &__question {
        @include mixins.text-large-regular();
        color: mixins.get-color(text, text-primary);
        padding: 16px 16px 8px;
        line-height: 28px;
        flex-shrink: 0;

        @at-root :host([mode="sheet"]) & {
            padding: 16px 0 8px;
        }
    }

    &__options {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 0 16px;

        @at-root :host([mode="sheet"]) & {
            padding: 0;
        }
    }
}

.poll-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 32px;
    min-height: 56px;
    border-radius: 16px;
    border: none;
    background: mixins.get-color(background, bg-gray-100);
    cursor: pointer;
    text-align: left;
    transition: all 100ms ease-out;

    &:hover:not(:disabled):not(.poll-option--selected) {
        background: mixins.get-color(background, bg-gray-150);
    }

    &:disabled {
        cursor: default;
    }

    &--selected {
        box-shadow: inset 0 0 0 2px #0f5059;
    }

    &__text {
        font-family: variables.$fontQuaternary;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: mixins.get-color(text, text-primary);
        flex: 1;
        padding-right: 16px;
    }

    &__radio {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid mixins.get-color(foreground, fg-disabled-subtle);
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 100ms ease-out;

        &--selected {
            background: mixins.get-color(teal, 600);
            border-color: mixins.get-color(teal, 600);
        }
    }

    &__radio-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: white;
    }
}
